import React, {useMemo} from "react";
import {Area, AreaChart, ResponsiveContainer, XAxis, YAxis} from "recharts";

export default function SkeletonAreaChart() {
    const data = useMemo(() => {
        const result = [];
        for (let i = 0; i < 25; i++) {
            result.push({
                name: `Label ${i + 1}`,
                value: Math.floor(Math.random() * 1000),
            });
        }
        return result;
    }, []);

    return (
        <ResponsiveContainer height="100%">
            <AreaChart data={data}>
                <XAxis dataKey="name" tick={false} height={1} />
                <YAxis tick={false} width={1} />
                <Area
                    dataKey={"value"}
                    isAnimationActive={false}
                    className="skeleton-area"
                />
            </AreaChart>
        </ResponsiveContainer>
    );
}
